<template>
  <v-flex>

    <v-dialog v-model="dialogFormularioReserva" :width="dialogWidth" persistent>
      <reserva-formulario
        :modelReserva="this.modelReserva"
        :accion="this.accion"
        @cerrarFormularioReserva="_actualizarDatos"
        @cerrar="dialogFormularioReserva = false"
      />
    </v-dialog>




    <v-card class="mt-2" color="rgb(250, 250, 250)">
      <v-toolbar :dark="!dark" dense color="blue-grey darken-2" flat>
        <v-toolbar-title :dark="!dark">INGRESOS</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-chip
          class="ml-4"
          @click="mostrarbusqueda = !mostrarbusqueda"
          :color="colorEBikeAccent1"
        >
          <v-avatar left>
            <v-icon>mdi-eye</v-icon>
          </v-avatar>
          <h5>BUSQUEDA</h5>
        </v-chip>
        <v-spacer></v-spacer>
        <div v-if="sheets[0].data.length > 0" class="hidden md:block">
          <div class="ml-0 flex items-center md:ml-0">
            <div class="ml-0 relative">
              <div>
                <xlsx-workbook raw>
                  <xlsx-sheet
                    :collection="sheet.data"
                    v-for="sheet in sheets"
                    :key="sheet.name"
                    :sheet-name="sheet.name"
                    raw
                  />
                  <xlsx-download filename="Ingresos.xlsx">
                    <v-chip class="ml-4" :color="colorEBikeAccent1">
                      <v-avatar left>
                        <v-icon>mdi-table-edit</v-icon>
                      </v-avatar>
                      <h5>Exportar a Excel</h5>
                    </v-chip>
                  </xlsx-download>
                </xlsx-workbook>
              </div>
            </div>
          </div>
        </div>
      </v-toolbar>

      <v-card-text>
        <v-row v-if="mostrarbusqueda" class="mt-0" justify="start" dense>
          <v-col class="mr-8" cols="3" align="start">
            <v-menu
              :dark="dark"
              v-model="date1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :dark="dark"
                  clearable
                  dense
                  outlined
                  v-model="busquedaDesde"
                  label="Desde"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                :dark="dark"
                color="success"
                locale="es"
                v-model="busquedaDesde"
                @input="date1 = false"
                first-day-of-week="1"
              ></v-date-picker>
            </v-menu>

            <v-menu
              :dark="dark"
              v-model="date2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :dark="dark"
                  clearable
                  dense
                  outlined
                  v-model="busquedaHasta"
                  label="Hasta"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                :dark="dark"
                color="success"
                locale="es"
                v-model="busquedaHasta"
                @input="date2 = false"
                first-day-of-week="1"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="5"> </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-row v-if="loading">
      <v-spacer />
      <v-row class="mt-12">
        <v-col>
          <v-progress-linear
            class="mt-12 mb-12"
            :color="colorEBikeAccent1"
            indeterminate
            width="200px"
            rounded
            height="6"
          ></v-progress-linear>
        </v-col>
      </v-row>
      <v-spacer />
    </v-row>

    <v-card v-else class="mt-2 mb-2" color="rgb(250, 250, 250, 1)">
      <v-card-text>
        <v-row v-if="ingresosFiltrados" class="mt-0" justify="start" dense>
          <v-col cols="12" align="center">
            <v-data-table
              locale="es"
              v-if="ingresosFiltrados"
              dense
              light
              :headers="headersLargo"
              :items="ingresosFiltrados"
              :items-per-page="ingresosFiltrados.length"
              hide-default-footer
              class="elevation-1"
            >
              <template v-slot:[`item.fecha_inicial`]="{ item }">
                <span>
                  {{ item.fecha_inicial }}
                </span>
              </template>

              <template v-slot:[`item.importeConIVA`]="{ item }">
                <span>
                  {{ item.importeConIVA + " €" }}
                </span>
              </template>

              <template v-slot:[`item.importeSinIVA`]="{ item }">
                <span>
                  {{ item.importeSinIVA + " €" }}
                </span>
              </template>

              <template v-slot:[`item.cliente.nombre`]="{ item }">
                <span>
                  {{ item.cliente.nombre }}
                </span>
              </template>

              <template v-slot:[`item.cliente.telefono`]="{ item }">
                <span>
                  {{ item.cliente.telefono }}
                </span>
              </template>

              <template v-slot:[`item.action`]="{ item }">
                <v-chip
                  class="mr-1"
                  label
                  small
                  :color="colorAccent2"
                  text-color="white"
                  link
                  @click="_editar(item)"
                >
                  Editar
                </v-chip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import {
  XlsxWorkbook,
  XlsxSheet,
  XlsxDownload,
} from "vue-xlsx/dist/vue-xlsx.es.js";
import XLSX from "xlsx";
import ReservaFormulario from "../components/formularios/ReservaFormulario.vue";

export default {
  components: {
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
    ReservaFormulario,
  },

  data: () => ({
    mostrarbusqueda: true,
    date1: false,
    date2: false,
    busquedaDesde: new Date().toISOString().substr(0, 10),
    busquedaHasta: new Date(Date.now() + 180 * 24 * 60 * 60 * 1000)
      .toISOString()
      .substr(0, 10),
    fechaEntre: [
      new Date().toISOString().substr(0, 10),
      new Date(Date.now() + 180 * 24 * 60 * 60 * 1000)
        .toISOString()
        .substr(0, 10),
    ],
    busquedaCliente: "",
    busquedaAgencia: null,
    
    modelReserva: null,
    accion: "",
    dialogFormularioReserva: false,

    sheets: [{ name: "Datos", data: [], raw: true }],

    headersLargo: [
      //  { text: "ID", align: "left", sortable: false, value: "id" },
      {
        text: "FECHA",
        align: "center",
        sortable: false,
        value: "fecha_inicial",
      },
      {
        text: "IMPORTE c/iva",
        align: "center",
        sortable: false,
        value: "importeConIVA",
      },
      {
        text: "IMPORTE s/iva",
        align: "center",
        sortable: false,
        value: "importeSinIVA",
      },

      {
        text: "Nº FACTURA",
        align: "center",
        sortable: false,
        value: "factura",
      },
      {
        text: "Nombre cliente",
        align: "left",
        sortable: false,
        value: "cliente.nombre",
      },

      {
        text: "Telefono cliente",
        align: "left",
        sortable: false,
        value: "cliente.telefono",
      },

      { text: "ACCIONES", value: "action", sortable: false, align: "center" },
    
    ],
  }),

  computed: {
    ...mapState([
      "loading",
      "drawer",
      "dark",
      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",

      "colorFront500",
      "colorFront400",
      "colorFront300",
      "colorFront200",
      "colorFront100",
      "colorEBikeAccent1",

      "colorAccent2",
      "colorAccent1",
      "colorBarraFormulario",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),

    ...mapState("estados", ["estados"]),
    ...mapState("ingresos", ["ingresos"]),
    ...mapState("reservas", ["dialogWidth", "reservaSelec"]),

    ingresosFiltrados() {
      return this.ingresos;
    },
  },

  watch: {
    busquedaDesde(value) {
      if (value != null && this.busquedaHasta != null) {
        this.fechaEntre[0] = value;
        this.fechaEntre[1] = this.busquedaHasta;
        this._getIngresos(true);
      } else {
        this.fechaEntre[0] = null;
        this.fechaEntre[1] = null;
      }
    },

    busquedaHasta(value) {
      if (value != null && this.busquedaDesde != null) {
        this.fechaEntre[0] = this.busquedaDesde;
        this.fechaEntre[1] = value;
        this._getIngresos(true);
      } else {
        this.fechaEntre[0] = null;
        this.fechaEntre[1] = null;
      }
    },
  },

  mounted() {
    this._getIngresos(true);
  },

  methods: {
    ...mapActions("ingresos", ["getIngresos"]),
    ...mapActions("reservas", ["getReserva"]),
    ...mapMutations("reservas", [
      "setReservaSelec",
    ]),

    

    async _getIngresos(showload) {
      const params = {};
      if (this.fechaEntre[0] && this.fechaEntre[1]) {
        params.fechaEntre = this.fechaEntre;
      }
      await this.getIngresos([this.access_token, params, showload]);
      this._prepareDataFromExcel();
    },

    _actualizarDatos() {
      this.dialogFormularioReserva = false;
      this._getIngresos(false);
    },

    _limpiarfiltros() {
      this.busquedaDesde = null;
      this.busquedaHasta = null;
      this._getIngresos(true);
    },

    async _editar(item) {
      let reserva = await this.getReserva([this.access_token, item.id]);
      this.setReservaSelec(reserva);
      let temp = JSON.parse(JSON.stringify(this.reservaSelec));
      this.modelReserva = temp;
      this.accion = "editar";
      this.dialogFormularioReserva = true;
    },

    _prepareDataFromExcel() {
      let res = [];
      for (let i = 0; i < this.ingresos.length; i++) {
        const e = this.ingresos[i];
        res.push({
          FECHA: e.fecha_inicial,
          "IMPORTE c/iva": e.importeConIVA.replaceAll(".", ",") + " €",
          "IMPORTE s/iva": e.importeSinIVA.replaceAll(".", ",") + " €",
          "Nº FACTURA": e.factura,
          "Nombre cliente": e.cliente.nombre,
          "Telefono cliente": e.cliente.telefono,
        });
      }

      this.sheets[0].data = res;
      var ws = XLSX.utils.aoa_to_sheet(this.sheets[0].data);

      var fmt = "0.00";
      /* change cell format of range B2:D4 */
      var range = { s: { r: 1, c: 1 }, e: { r: 2, c: 3 } };
      for (var R = range.s.r; R <= range.e.r; ++R) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var cell = ws[XLSX.utils.encode_cell({ r: R, c: C })];
          if (!cell || cell.t != "n") continue; // only format numeric cells
          cell.z = fmt;
        }
      }
    },
  },
};
</script>
